import { environment } from '../../../environments/environment';
import { Utility } from '../utility';

export const emojiTianXingTu = {
    label: '甜心兔',
    height: 90,
    width: 90,
    path:"/upload/facetime/tianxingtu/",
    range:[[20210701,20210724]]
    // items: [
    //     {
    //         'not': 20210701,
    //         'id': 20210701,
    //         'image': '/upload/facetime/tianxingtu/20210701.gif',
    //         'title': 'Hi',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210701)',
    //         'GroupID': 202107
    //     },
    //     {
    //         'not': 20210702,
    //         'id': 20210702,
    //         'image': '/upload/facetime/tianxingtu/20210702.gif',
    //         'title': 'mua~',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210702)',
    //         'GroupID': 202107
    //     },
    //     {
    //         'not': 20210703,
    //         'id': 20210703,
    //         'image': '/upload/facetime/tianxingtu/20210703.gif',
    //         'title': 'OK',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210703)',
    //         'GroupID': 202107
    //     },
    //     {
    //         'not': 20210704,
    //         'id': 20210704,
    //         'image': '/upload/facetime/tianxingtu/20210704.gif',
    //         'title': '啊啊啊',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210704)',
    //         'GroupID': 202107
    //     },
    //     {
    //         'not': 20210705,
    //         'id': 20210705,
    //         'image': '/upload/facetime/tianxingtu/20210705.gif',
    //         'title': '安慰',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210705)',
    //         'GroupID': 202107
    //     },
    //     {
    //         'not': 20210706,
    //         'id': 20210706,
    //         'image': '/upload/facetime/tianxingtu/20210706.gif',
    //         'title': '抱抱',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210706)',
    //         'GroupID': 202107
    //     },
    //     {
    //         'not': 20210707,
    //         'id': 20210707,
    //         'image': '/upload/facetime/tianxingtu/20210707.gif',
    //         'title': '暴风哭泣',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210707)',
    //         'GroupID': 202107
    //     },
    //     {
    //         'not': 20210708,
    //         'id': 20210708,
    //         'image': '/upload/facetime/tianxingtu/20210708.gif',
    //         'title': '比心',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210708)',
    //         'GroupID': 202107
    //     },
    //     {
    //         'not': 20210709,
    //         'id': 20210709,
    //         'image': '/upload/facetime/tianxingtu/20210709.gif',
    //         'title': '哈哈哈哈',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210709)',
    //         'GroupID': 202107
    //     },
    //     {
    //         'not': 20210710,
    //         'id': 202107010,
    //         'image': '/upload/facetime/tianxingtu/20210710.gif',
    //         'title': '好',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210710)',
            
    //         'GroupID': 202107
    //     },
    //     {
    //         'not': 20210711,
    //         'id': 20210711,
    //         'image': '/upload/facetime/tianxingtu/20210711.gif',
    //         'title': '好朋友',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210711)',
            
    //         'GroupID': 202107
    //     },
    //     {
    //         'not': 20210712,
    //         'id': 20210712,
    //         'image': '/upload/facetime/tianxingtu/20210712.gif',
    //         'title': '加油！',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210712)',
            
    //         'GroupID': 202107
    //     },
    //     {
    //         'not': 20210713,
    //         'id': 20210713,
    //         'image': '/upload/facetime/tianxingtu/20210713.gif',
    //         'title': '可爱',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210713)',
            
    //         'GroupID': 202107
    //     },
    //     {
    //         'not': 20210714,
    //         'id': 20210714,
    //         'image': '/upload/facetime/tianxingtu/20210714.gif',
    //         'title': '哭泣',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210714)',
            
    //         'GroupID': 202107
    //     },
    //     {
    //         'not': 20210715,
    //         'id': 20210715,
    //         'image': '/upload/facetime/tianxingtu/20210715.gif',
    //         'title': '难过',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210715)',
            
    //         'GroupID': 202107
    //     },
    //     {
    //         'not': 20210716,
    //         'id': 20210716,
    //         'image': '/upload/facetime/tianxingtu/20210716.gif',
    //         'title': '嗯',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210716)',
            
    //         'GroupID': 202107
    //     },
    //     {
    //         'not': 20210717,
    //         'id': 20210717,
    //         'image': '/upload/facetime/tianxingtu/20210717.gif',
    //         'title': '你最好了',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210717)',
            
    //         'GroupID': 202107
    //     },
    //     {
    //         'not': 20210718,
    //         'id': 20210718,
    //         'image': '/upload/facetime/tianxingtu/20210718.gif',
    //         'title': '期待',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210718)',
            
    //         'GroupID': 202107
    //     },
    //     {
    //         'not': 20210719,
    //         'id': 20210719,
    //         'image': '/upload/facetime/tianxingtu/20210719.gif',
    //         'title': '送你心',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210719)',
            
    //         'GroupID': 202107
    //     },
    //     {
    //         'not': 20210720,
    //         'id': 20210720,
    //         'image': '/upload/facetime/tianxingtu/20210720.gif',
    //         'title': '哇',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210720)',
            
    //         'GroupID': 202107
    //     },
    //     {
    //         'not': 20210721,
    //         'id': 20210721,
    //         'image': '/upload/facetime/tianxingtu/20210721.gif',
    //         'title': '晚安',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210721)',
            
    //         'GroupID': 202107
    //     },
    //     {
    //         'not': 20210722,
    //         'id': 20210722,
    //         'image': '/upload/facetime/tianxingtu/20210722.gif',
    //         'title': '谢谢',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210722)',
            
    //         'GroupID': 202107
    //     },
    //     {
    //         'not': 20210723,
    //         'id': 20210723,
    //         'image': '/upload/facetime/tianxingtu/20210723.gif',
    //         'title': '赞',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210723)',
            
    //         'GroupID': 202107
    //     },
    //     {
    //         'not': 20210724,
    //         'id': 20210724,
    //         'image': '/upload/facetime/tianxingtu/20210724.gif',
    //         'title': '追逐',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210724)',
            
    //         'GroupID': 202107
    //     },
    // ]
}
